module.exports = __webpack_public_path__ + "62b612c4ee6710f91ec37fe7cc23ddee.pdf";